import { getFunctions, httpsCallable } from 'firebase/functions'
import { app } from '../firebase/config'
import type {
  ImproveTextRequest,
  ImproveTextResponse,
  ParsePdfResponse,
  CVReviewResponse,
  ReviewCVRequest,
} from '../../types/api'
import type { CV } from '../../types/cv'

const functions = getFunctions(app)

export async function improveText(
  request: ImproveTextRequest
): Promise<ImproveTextResponse> {
  const improveTextFn = httpsCallable<ImproveTextRequest, ImproveTextResponse>(
    functions,
    'improveTextFunction'
  )

  const result = await improveTextFn(request)
  return result.data
}

export async function parsePdfWithAI(
  pdfText: string,
  options?: {
    language?: 'es' | 'en'
    fileName?: string
    fileSize?: number
  }
): Promise<ParsePdfResponse> {
  const parsePdfFn = httpsCallable<
    { pdfText: string; language?: string; fileName?: string; fileSize?: number },
    ParsePdfResponse
  >(functions, 'parsePdfFunction')

  const result = await parsePdfFn({
    pdfText,
    language: options?.language || 'es',
    fileName: options?.fileName,
    fileSize: options?.fileSize,
  })
  return result.data
}

export async function reviewCV(
  cv: CV,
  language: 'es' | 'en' = 'es'
): Promise<CVReviewResponse> {
  const reviewCVFn = httpsCallable<ReviewCVRequest, CVReviewResponse>(
    functions,
    'reviewCVFunction'
  )

  const result = await reviewCVFn({ cv, language })
  return result.data
}
